import { Component, Inject, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogRef } from '../../aero/aero-dialog/types';

/**
 * Component for adding email addresses with validation and dynamic dialog integration.
 * Provides an email input field with built-in validation, autofocus, and real-time validation feedback.
 * Manages dialog state based on email input validity and notifies parent components of value changes.
 */
@Component({
  selector: 'bulb-add-email',
  template: `
    <aero-input
      type="email"
      name="email"
      [email]="true"
      [autofocus]="true"
      bulbValidationField
      bulbAjaxValidation="emailUnique"
      [label]="'account_settings_email' | translate"
      [(ngModel)]="email"
      (aeroInputNgModelEmitter)="onModelChange($event)"
      (ngModelChange)="onChange()"
      [required]="true">
    </aero-input>`,
  standalone: false,
})
export class AddEmailComponent implements OnInit {
  email = '';

  /**
   * Creates a new dialog component instance.
   * @param dialogRef - The reference to the dialog that was opened
   * @param config - The configuration object for the dynamic dialog
   */
  constructor(
    @Inject('DialogRef') private dialogRef: DialogRef,
    public config: DynamicDialogConfig,
  ) {}

  /**
   * Initializes the component and sets up the dialog configuration.
   * Disables the primary button in the dialog.
   *
   * @return {void}
   */
  ngOnInit(): void {
    this.dialogRef.setPrimaryDisabled(true);
  }

  /**
   * Automatically disables the dialog's primary button if empty,
   * invalid format, or while AJAX uniqueness check is pending.
   */
  onModelChange(model: any): void {
    if (model) {
      this.dialogRef.setPrimaryDisabled(model.invalid || model.pending);
    }
  }

  /**
   * Handles the change event for the email input.
   * Updates the dialog's primary button disabled state based on email validity
   * and notifies the configuration data of the value change.
   *
   * @return {void}
   */
  onChange(): void {
    if (this.config.data?.valueChange) {
      this.config.data.valueChange(this.email);
    }
  }
}
